<template>
  <div>
    <StructuresTable :data="tableData" :tag-families="tableTagFamilies" :search-tag="searchTag">
    </StructuresTable>
    <LoadingOverlay :is-loading="!hydrated"></LoadingOverlay>
  </div>
</template>

<script>
import StructuresTable from "./structures/StructuresTable.vue";
import LoadingOverlay from "./shared/LoadingOverlay.vue";

export default {
  name: "Structures",
  data() {
    return {
      tableData: [],
      tableTagFamilies: [],
      searchTag: '',
      searchQuery: '',
      searchDir: '',
      hydrated: false
    }
  },
  components: {
    StructuresTable,
    LoadingOverlay
  },
  created() {
    this.searchQuery = this.$route.query.search || '';
    this.searchTag = this.$route.query.tag || '';
    this.searchDir = this.$route.query.dir || '';
    this.loadData();
  },
  watch: {
    '$route'(to, from) {
      if (to.path === '/structures') {
        this.searchQuery = to.query.search || '';
        this.searchTag = to.query.tag || '';
        this.searchDir = to.query.dir || '';
        this.loadData();
      }
    }
  },
  methods: {
    loadData() {
      fetch('/api/structures?' + new URLSearchParams({
        search: this.searchQuery,
        tag: this.searchTag,
        dir: this.searchDir
      })).then((response) => response.json()).then((data) => {
        this.tableData = data.data;
        this.tableTagFamilies = data.header;
        this.hydrated = true;
      })
    },
  },
};
</script>
